/* MD Solutions · Messung für den Hinweis "Trade-In-Preis": "Hinweis angezeigt" und "Klick auf Trade-In-Preis anfragen", jeweils mit Quelle. */
(function () {
  if (window.__mdxTinInit) return;
  window.__mdxTinInit = true;
  var push = function (name, quelle) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: name, quelle: quelle }); } catch (e) {}
  };
  var init = function () {
    var notes = document.querySelectorAll('[data-mdx-tin]');
    if (!notes.length) return;
    notes.forEach(function (el) {
      var quelle = el.getAttribute('data-mdx-tin');
      // Produktseite: Hinweis direkt über den Kauf-Button setzen (der Button sitzt hier vor dem Preis)
      if (quelle === 'produktseite') {
        var btns = document.querySelector('.product-form__buttons');
        if (btns && btns.parentNode) btns.parentNode.insertBefore(el, btns);
      }
      var sent = false;
      var view = function () { if (!sent) { sent = true; push('tradein_hinweis_angezeigt', quelle); } };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { view(); io.disconnect(); } });
        }, { threshold: 0.5 });
        io.observe(el);
      } else { view(); }
      var a = el.querySelector('[data-mdx-tin-link]');
      if (a) a.addEventListener('click', function () { push('tradein_hinweis_klick', quelle); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
